import { Button, FormLayout, GridFieldGroup, Heading, Paragraph, TextInput, useDialog } from '@expressable/syntax-ds';
import { DirectSignupNoPCPInfoDialog } from 'components/Dialog';
import { useSignupDirectCtx } from 'domains/signupDirect/context';
import { DIRECT_SIGNUP_MIXPANEL_EVENTS } from 'domains/signupDirect/misc/mixpanelTracking';
import { HeadingCombo } from 'domains/signupDirect/SyntaxComps/HeadingCombo';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useTrack } from 'utils/hooks/useMixPanel';

const DirectSignupPPISection: React.FC = () => {
  const { track } = useTrack();
  const { t } = useTranslation();
  const { register } = useFormContext();
  const { isResumedLead } = useSignupDirectCtx();
  const { dialogStateProps, onOpen, onClose: onCloseDialog } = useDialog();

  const onDismissNoPPIDialog = () => {
    track(DIRECT_SIGNUP_MIXPANEL_EVENTS.NO_PCP, { isResumedLead });

    onCloseDialog();
  };

  return (
    <>
      <FormLayout.Fields className="mobile-xs-d:gap-e24 tablet-d:gap-e32">
        <HeadingCombo>
          <Heading noDefaultMargins level="h5">
            {t('directSignup.sections.primaryPhysician.title')}
          </Heading>
          <Paragraph variant="secondary" size="md">
            {t('directSignup.sections.primaryPhysician.subTitle')}
          </Paragraph>
        </HeadingCombo>

        <TextInput
          data-testid="primary-physician-name-input"
          label={t('directSignup.sections.primaryPhysician.labels.physicianName')}
          {...register('billingInfo.primaryPhysician.name')}
        />
        <TextInput
          data-testid="primary-physician-office-name-input"
          label={t('directSignup.sections.primaryPhysician.labels.physicianOfficeName')}
          {...register('billingInfo.primaryPhysician.officeName')}
        />

        <GridFieldGroup>
          <TextInput
            data-testid="primary-physician-phone-input"
            label={t('directSignup.sections.primaryPhysician.labels.physicianPhone')}
            type="tel"
            {...register('billingInfo.primaryPhysician.phone')}
          />
          <TextInput
            data-testid="primary-physician-email-input"
            label={t('directSignup.sections.primaryPhysician.labels.physicianWebsite')}
            type="url"
            {...register('billingInfo.primaryPhysician.website')}
          />
        </GridFieldGroup>

        <Button data-testid="no-pcp-button" variant="link" onClick={onOpen}>
          {t('directSignup.sections.primaryPhysician.labels.noPhysicianInfo')}
        </Button>
      </FormLayout.Fields>
      <DirectSignupNoPCPInfoDialog {...dialogStateProps} onConfirm={onDismissNoPPIDialog} />
    </>
  );
};

export default DirectSignupPPISection;
